(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bloom-article-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bloom-article-carousel')) {
  customElements.define('bloom-article-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.rail = this.querySelector('.bh-edit__rail');
      this.grid = this.querySelector('.bh-edit__grid');
      this.items = Array.from(this.querySelectorAll('.bh-edit__item'));
      this.controls = this.querySelector('.bh-edit__controls');
      this.toggle = this.querySelector('[data-carousel-toggle]');
      this.announcement = this.querySelector('[data-carousel-announcement]');
      if (!this.rail || !this.items.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.focusPaused = false;
      this.interacting = false;
      this.inView = false;
      this.scrolling = false;
      this.index = 0;
      this.queuedDirection = 0;
      this.timer = null;
      this.items.forEach((item, index) => { item.dataset.carouselIndex = String(index); });
      this.clones = [];
      if (this.items.length > 1) {
        const copy = item => {
          const clone = item.cloneNode(true);
          clone.dataset.carouselClone = '';
          [clone, ...clone.querySelectorAll('*')].forEach(node => {
            node.removeAttribute('id');
            Array.from(node.attributes).forEach(attribute => {
              if (attribute.name.startsWith('data-shopify-')) node.removeAttribute(attribute.name);
            });
          });
          clone.inert = true;
          clone.setAttribute('aria-hidden', 'true');
          this.clones.push(clone);
          return clone;
        };
        this.grid.prepend(...this.items.map(copy));
        this.grid.append(...this.items.map(copy));
      }
      this.querySelector('[data-carousel-previous]').addEventListener('click', () => this.advance(-1, true), options);
      this.querySelector('[data-carousel-next]').addEventListener('click', () => this.advance(1, true), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        if (!this.paused) this.focusPaused = false;
        this.updateToggle();
        this.schedule(true);
      }, options);
      this.addEventListener('focusin', event => {
        if (!event.target.matches(':focus-visible')) return;
        this.focusPaused = true;
        this.schedule();
      }, options);
      this.addEventListener('focusout', event => {
        if (this.contains(event.relatedTarget)) return;
        this.focusPaused = false;
        this.schedule();
      }, options);
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.advance(event.key === 'ArrowRight' ? 1 : -1, true);
      }, options);
      this.rail.addEventListener('pointerdown', () => {
        this.interacting = true;
        this.schedule();
      }, options);
      const release = () => {
        if (!this.interacting) return;
        this.interacting = false;
        this.schedule(true);
      };
      window.addEventListener('pointerup', release, options);
      window.addEventListener('pointercancel', release, options);
      this.rail.addEventListener('wheel', event => {
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        this.interacting = true;
        this.schedule();
        window.clearTimeout(this.wheelTimer);
        this.wheelTimer = window.setTimeout(release, 200);
      }, { ...options, passive: true });
      this.rail.addEventListener('scroll', () => {
        this.scrolling = true;
        this.sync();
        this.waitForScroll();
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updateToggle();
        this.schedule();
      }, options);
      this.intersection = new IntersectionObserver(entries => {
        const visible = entries[entries.length - 1].isIntersecting;
        if (visible === this.inView) return;
        this.inView = visible;
        this.schedule();
      }, { threshold: 0 });
      this.intersection.observe(this);
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.rail);
      this.updateToggle();
      this.measure();
    }
    measure() {
      const visible = Math.min(this.items.length, Number.parseInt(getComputedStyle(this).getPropertyValue('--bh-edit-visible'), 10) || 3);
      const width = this.rail.clientWidth;
      if (!width || (this.step && width === this.measuredWidth && visible === this.visibleCount)) return;
      this.measuredWidth = width;
      this.visibleCount = visible;
      this.canLoop = this.items.length > visible;
      this.clones.forEach(clone => { clone.hidden = !this.canLoop; });
      this.rendered = this.canLoop ? Array.from(this.grid.children) : this.items;
      this.base = this.canLoop ? this.items.length : 0;
      this.step = this.rendered.length > 1 ? this.rendered[1].getBoundingClientRect().left - this.rendered[0].getBoundingClientRect().left : width;
      this.physicalIndex = this.base + (this.canLoop ? this.index : 0);
      this.controls.hidden = !this.canLoop;
      this.rail.scrollTo({ left: this.physicalIndex * this.step, behavior: 'instant' });
      this.sync();
      this.schedule();
    }
    sync() {
      if (!this.step) return;
      this.physicalIndex = Math.max(0, Math.round(this.rail.scrollLeft / this.step));
      this.index = ((this.physicalIndex - this.base) % this.items.length + this.items.length) % this.items.length;
      this.rendered.forEach((item, index) => {
        const visible = index >= this.physicalIndex && index < this.physicalIndex + this.visibleCount;
        item.inert = !visible;
        if (visible) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
      });
    }
    waitForScroll() {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => this.settle(), 140);
    }
    settle() {
      window.clearTimeout(this.scrollTimer);
      this.scrolling = false;
      this.sync();
      if (this.canLoop && (this.physicalIndex < this.base || this.physicalIndex >= this.base + this.items.length)) {
        const offset = this.physicalIndex < this.base ? this.items.length : -this.items.length;
        const focusedIndex = this.rendered.findIndex(item => item.contains(document.activeElement));
        this.rail.scrollTo({ left: this.rail.scrollLeft + offset * this.step, behavior: 'instant' });
        this.sync();
        if (focusedIndex >= 0) this.rendered[focusedIndex + offset]?.querySelector('a')?.focus({ preventScroll: true });
      }
      if (this.queuedDirection) {
        const direction = Math.sign(this.queuedDirection);
        this.queuedDirection -= direction;
        this.scrolling = false;
        this.advance(direction, true);
      }
      this.schedule();
    }
    advance(direction, announce = false) {
      if (!this.canLoop || !this.step) return;
      if (this.scrolling) {
        if (announce) this.queuedDirection += direction;
        return;
      }
      this.sync();
      const next = this.physicalIndex + direction;
      this.scrolling = true;
      this.rail.scrollTo({ left: next * this.step, behavior: this.motion.matches ? 'instant' : 'smooth' });
      this.waitForScroll();
      if (announce) {
        const first = ((next - this.base) % this.items.length + this.items.length) % this.items.length;
        const positions = Array.from({ length: this.visibleCount }, (_, index) => (first + index) % this.items.length + 1);
        this.announcement.textContent = this.announcement.dataset.statusTemplate.replace('[positions]', positions.join(', '));
      }
      this.schedule(announce);
    }
    updateToggle() {
      const label = this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.querySelector('[data-carousel-toggle-text]').textContent = label;
      this.toggle.setAttribute('aria-label', label);
    }
    schedule(reset = false) {
      const allowed = this.isConnected && !this.paused && !this.focusPaused && !this.interacting && this.inView && !document.hidden && this.canLoop;
      if (!allowed || reset) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      if (!allowed || this.timer !== null) return;
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.advance(1);
        this.schedule();
      }, 10000);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.intersection?.disconnect();
      this.resize?.disconnect();
      window.clearTimeout(this.timer);
      window.clearTimeout(this.scrollTimer);
      window.clearTimeout(this.wheelTimer);
      this.clones?.forEach(clone => clone.remove());
      this.items?.forEach(item => { item.inert = false; item.removeAttribute('aria-hidden'); });
      this.abort = null;
      this.step = 0;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bloom-product-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bloom-product-rating')) {
    customElements.define('bloom-product-rating', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        const target = document.getElementById(this.link.hash.slice(1));
        this.summary = target?.querySelector('[data-review-summary]');
        if (!this.summary) return;
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.summary, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'aria-label', 'hidden'] });
        this.sync();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
      sync() {
        const stars = this.summary.querySelector('[data-review-stars]');
        const countText = this.summary.querySelector('[data-review-count]')?.textContent.trim();
        if (!stars || !countText) return;
        const count = Number(countText.replace(/[^0-9]/g, ''));
        this.hidden = this.summary.hidden || count === 0;
        this.querySelector('.bloom-product-rating__count').textContent = '(' + count + ')';
        this.querySelector('.bloom-product-rating__stars').style.setProperty('--rating-fill', stars.style.getPropertyValue('--review-star-fill'));
        this.link.setAttribute('aria-label', this.dataset.label + ': ' + stars.getAttribute('aria-label') + ', ' + countText);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bloom-store-community"] && !Shopify.designMode) return;
  try {
    (() => {
  const instances = new WeakMap();
  let sequence = 0;
  const initialize = (root) => {
    if (instances.has(root)) return;
    const store = root.querySelector('[data-bloom-store-reviews]');
    const panel = store?.closest('[data-bh-review-panel]');
    if (!store || !panel) return;
    const heading = root.querySelector('h2[id]');
    const entries = new Map();
    const photos = new Map();
    const marked = new Set();
    const listeners = new AbortController();
    const signal = listeners.signal;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const template = document.querySelector('[data-bloom-native-controls-template]');
    const controls = template?.content.firstElementChild.cloneNode(true);
    const toggle = controls?.querySelector('[data-bloom-native-toggle]');
    const footer = panel.querySelector('.bh-review-panel__footer');
    if (controls && footer) footer.append(controls);
    let gallery = root.querySelector('.bh-review-photos');
    const configuredGallery = gallery;
    const originalPhotoCount = gallery?.style.getPropertyValue('--bh-review-photo-count');
    const originalTabIndex = gallery?.getAttribute('tabindex');
    let rail = null;
    let scroll = null;
    let cards = [];
    let attempts = 0;
    let mountTimer = null;
    let autoTimer = null;
    let frame = null;
    let destroyed = false;
    let visible = false;
    let hovered = false;
    let dragging = false;
    let overflow = false;
    let userPaused = motion.matches;
    const stop = () => { window.clearInterval(autoTimer); autoTimer = null; };
    const mayPlay = () => !destroyed && overflow && visible && !userPaused && !hovered && !dragging && !document.hidden && (!panel.contains(document.activeElement) || document.activeElement === toggle);
    const start = () => {
      stop();
      if (mayPlay()) autoTimer = window.setInterval(() => { if (mayPlay()) move(1); }, 10000);
    };
    const updateToggle = () => {
      if (!toggle) return;
      toggle.dataset.paused = String(userPaused);
      toggle.setAttribute('aria-label', userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
    };
    const move = (direction) => {
      if (!scroll || !overflow || cards.length < 2) return;
      const firstLeft = cards[0].getBoundingClientRect().left;
      const positions = cards.map((card) => card.getBoundingClientRect().left - firstLeft);
      const max = Math.max(0, scroll.scrollWidth - scroll.clientWidth);
      const current = Math.max(0, scroll.scrollLeft);
      let next;
      if (direction > 0) next = current >= max - 2 ? 0 : Math.min(max, positions.find((position) => position > current + 2) ?? max);
      else next = current <= 2 ? max : [...positions].reverse().find((position) => position < current - 2) ?? 0;
      scroll.scrollTo({ left: next, behavior: motion.matches ? 'instant' : 'smooth' });
    };
    const measure = () => {
      frame = null;
      if (destroyed) return;
      if (scroll?.swiper) { scroll.swiper.autoplay?.stop(); scroll.swiper.allowTouchMove = false; }
      overflow = Boolean(scroll && cards.length > 1 && scroll.clientWidth > 0 && scroll.scrollWidth > scroll.clientWidth + 2);
      if (scroll) scroll.tabIndex = overflow ? 0 : -1;
      if (controls) controls.hidden = !overflow;
      if (gallery) gallery.tabIndex = gallery.scrollWidth > gallery.clientWidth + 2 ? 0 : -1;
      updateToggle();
      start();
    };
    const scheduleMeasure = () => {
      if (destroyed || frame !== null) return;
      frame = window.requestAnimationFrame(measure);
    };
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(scheduleMeasure) : null;
    const safeImage = (image) => {
      const raw = image.getAttribute('data-src') || image.currentSrc || image.getAttribute('src');
      if (!raw || /(?:placeholder|transparent|spacer|no[-_]?image)(?:[./_?-]|$)/i.test(raw)) return null;
      if (Number(image.getAttribute('width')) === 1 && Number(image.getAttribute('height')) === 1) return null;
      try {
        const url = new URL(raw, document.baseURI);
        if (!['https:', 'http:'].includes(url.protocol)) return null;
        const key = new URL(url);
        ['width', 'height', 'crop', 'format', 'v', 'scale'].forEach((parameter) => key.searchParams.delete(parameter));
        key.hash = '';
        return { url: url.href, key: key.href, alt: image.getAttribute('alt') || '' };
      } catch { return null; }
    };
    const reviewPhotos = (item) => [...item.querySelectorAll('.wc_review_item_thumbnail img')].map(safeImage).filter(Boolean);
    const reviewText = (source) => source ? (source.querySelector('[data-desc]')?.getAttribute('data-desc') || source.getAttribute('data-desc') || source.textContent || '').trim() : '';
    const cardFor = (item) => item.parentElement.classList.contains('swiper-slide') ? item.parentElement : item;
    const isReview = (item) => {
      if (item.closest('template, .swiper-slide-duplicate, [aria-busy="true"], .skeleton, .placeholder, .wc_review_skeleton')) return false;
      if (!item.querySelector('.wc_review_item_info, .wc_review_item_content')) return false;
      return Boolean(reviewText(item.querySelector('.wc_review_item_body_desc')) || item.querySelector('.wc_review_item_body_title')?.textContent.trim() || reviewPhotos(item).length || [...item.querySelectorAll('.wc_review_author_name h6, .wc_review_date, .wc_grid_date_cls')].some((node) => node.textContent.trim()) || item.querySelector('[data-rating], [data-star], .wc_review_item_star, .wc_review_item_rating, .wc_review_item_stars, .wc_review_star'));
    };
    const syncPhotos = (items) => {
      const desired = new Map();
      const configuredKeys = new Set([...(configuredGallery?.querySelectorAll('li:not([data-bloom-submitted-photo]) img') || [])].map(safeImage).filter(Boolean).map((photo) => photo.key));
      items.forEach((item) => reviewPhotos(item).forEach((photo) => {
        if (!configuredKeys.has(photo.key) && !desired.has(photo.key)) desired.set(photo.key, photo);
      }));
      photos.forEach((node, key) => { if (!desired.has(key)) { node.remove(); photos.delete(key); } });
      if (desired.size && !gallery) {
        gallery = document.createElement('ul');
        gallery.className = 'bh-review-photos';
        gallery.setAttribute('role', 'list');
        if (heading) gallery.setAttribute('aria-labelledby', heading.id);
        panel.before(gallery);
        resizeObserver?.observe(gallery);
      }
      desired.forEach((photo, key) => {
        if (photos.has(key)) return;
        const node = document.createElement('li');
        node.className = 'bh-review-gallery-photo';
        node.dataset.bloomSubmittedPhoto = '';
        const image = document.createElement('img');
        image.src = photo.url;
        image.alt = photo.alt || configuredGallery?.querySelector('img')?.alt || heading?.textContent.trim() || '';
        image.loading = 'lazy';
        image.decoding = 'async';
        node.append(image);
        gallery.append(node);
        photos.set(key, node);
      });
      if (gallery) {
        gallery.toggleAttribute('data-bloom-native-photos', photos.size > 0);
        gallery.style.setProperty('--bh-review-photo-count', String(Math.max(1, Math.min(6, gallery.children.length))));
        if (!configuredGallery && !photos.size) { resizeObserver?.unobserve(gallery); gallery.remove(); gallery = null; }
      }
    };
    const update = () => {
      if (destroyed) return;
      const items = [...store.querySelectorAll('li.wc_review_widget_item')];
      const valid = items.filter(isReview);
      const sources = valid.map((item) => item.querySelector('.wc_review_item_body_desc')).filter((source) => reviewText(source));
      root.toggleAttribute('data-store-reviews-ready', valid.length > 0);
      panel.dataset.bloomReviewsSource = valid.length ? 'native' : 'fallback';
      entries.forEach((text, source) => {
        if (!sources.includes(source)) { text.remove(); source.removeAttribute('data-bloom-native-original'); entries.delete(source); }
      });
      marked.forEach((card) => { card.removeAttribute('data-bloom-native-card'); card.removeAttribute('data-bloom-native-excluded'); });
      marked.clear();
      items.forEach((item) => {
        const card = cardFor(item);
        card.toggleAttribute('data-bloom-native-excluded', !valid.includes(item));
        marked.add(card);
      });
      const nextRail = valid[0] ? cardFor(valid[0]).parentElement : null;
      const nextScroll = nextRail?.parentElement || null;
      if (rail !== nextRail) rail?.removeAttribute('data-bloom-native-rail');
      if (scroll !== nextScroll) {
        if (scroll) { resizeObserver?.unobserve(scroll); scroll.removeAttribute('data-bloom-native-scroll'); }
        scroll = nextScroll;
        if (scroll) {
          scroll.dataset.bloomNativeScroll = '';
          scroll.id ||= 'BloomNativeReviewRail-' + (++sequence);
          scroll.setAttribute('role', 'region');
          if (heading) scroll.setAttribute('aria-labelledby', heading.id);
          controls?.querySelectorAll('button').forEach((button) => button.setAttribute('aria-controls', scroll.id));
          resizeObserver?.observe(scroll);
        }
      }
      rail = nextRail;
      if (rail) rail.dataset.bloomNativeRail = '';
      cards = valid.map(cardFor).filter((card) => card.parentElement === rail);
      valid.forEach((item) => { cardFor(item).dataset.bloomNativeCard = ''; });
      sources.forEach((source) => {
        let text = entries.get(source);
        if (!text?.isConnected) {
          text?.remove();
          text = document.createElement('div');
          text.className = 'bh-native-review-text';
          source.after(text);
          entries.set(source, text);
        }
        const fullText = reviewText(source);
        if (text.textContent !== fullText) text.textContent = fullText;
        source.dataset.bloomNativeOriginal = '';
      });
      syncPhotos(valid);
      scheduleMeasure();
    };
    const mount = () => {
      attempts += 1;
      if (!root.isConnected || store.classList.contains('wc_rivyo_widget_root') || attempts > 30) { window.clearInterval(mountTimer); return; }
      if (typeof window.revyoScriptLoad === 'function') { window.revyoScriptLoad(); window.clearInterval(mountTimer); }
    };
    const observer = new MutationObserver(update);
    observer.observe(store, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-desc', 'src', 'data-src'] });
    resizeObserver?.observe(store);
    if (gallery) resizeObserver?.observe(gallery);
    const intersectionObserver = new IntersectionObserver((records) => { visible = records[0].isIntersecting; start(); }, { threshold: 0.15 });
    intersectionObserver.observe(panel);
    controls?.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !controls.contains(button)) return;
      if (button === toggle) { userPaused = !userPaused; updateToggle(); }
      else move(button.hasAttribute('data-bloom-native-next') ? 1 : -1);
      start();
    }, { signal });
    panel.addEventListener('mouseenter', () => { hovered = true; stop(); }, { signal });
    panel.addEventListener('mouseleave', () => { hovered = false; start(); }, { signal });
    panel.addEventListener('focusin', () => { if (document.activeElement !== toggle) stop(); }, { signal });
    panel.addEventListener('focusout', () => window.requestAnimationFrame(start), { signal });
    store.addEventListener('pointerdown', () => { dragging = true; stop(); }, { signal, passive: true });
    const endDrag = () => { dragging = false; start(); };
    window.addEventListener('pointerup', endDrag, { signal });
    window.addEventListener('pointercancel', endDrag, { signal });
    store.addEventListener('keydown', (event) => {
      if (event.target !== scroll || event.altKey || event.ctrlKey || event.metaKey) return;
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') scroll.scrollTo({ left: event.key === 'Home' ? 0 : scroll.scrollWidth - scroll.clientWidth, behavior: motion.matches ? 'instant' : 'smooth' });
      else move(event.key === 'ArrowRight' ? 1 : -1);
      start();
    }, { signal });
    window.addEventListener('resize', scheduleMeasure, { signal });
    document.addEventListener('visibilitychange', start, { signal });
    motion.addEventListener('change', () => { userPaused = motion.matches; updateToggle(); start(); }, { signal });
    if (document.fonts?.ready) document.fonts.ready.then(scheduleMeasure);
    instances.set(root, () => {
      destroyed = true;
      stop();
      listeners.abort();
      observer.disconnect();
      resizeObserver?.disconnect();
      intersectionObserver.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
      window.clearInterval(mountTimer);
      entries.forEach((text, source) => { text.remove(); source.removeAttribute('data-bloom-native-original'); });
      photos.forEach((node) => node.remove());
      marked.forEach((card) => { card.removeAttribute('data-bloom-native-card'); card.removeAttribute('data-bloom-native-excluded'); });
      rail?.removeAttribute('data-bloom-native-rail');
      scroll?.removeAttribute('data-bloom-native-scroll');
      if (configuredGallery) {
        configuredGallery.removeAttribute('data-bloom-native-photos');
        if (originalPhotoCount) configuredGallery.style.setProperty('--bh-review-photo-count', originalPhotoCount);
        else configuredGallery.style.removeProperty('--bh-review-photo-count');
        if (originalTabIndex === null) configuredGallery.removeAttribute('tabindex');
        else configuredGallery.setAttribute('tabindex', originalTabIndex);
      } else gallery?.remove();
      controls?.remove();
      root.removeAttribute('data-store-reviews-ready');
      panel.dataset.bloomReviewsSource = 'fallback';
      instances.delete(root);
    });
    mountTimer = window.setInterval(mount, 500);
    update();
    mount();
  };
  const roots = (scope) => [
    ...(scope.matches?.('[data-bh-voices]') ? [scope] : []),
    ...scope.querySelectorAll('[data-bh-voices]')
  ];
  const init = (scope) => roots(scope).forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => roots(event.target).forEach((root) => instances.get(root)?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
  } catch(e) { console.error(e); }
})();

})();
